import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import CommonLoader from 'components/common/CommonLoader';
import ViewLiveButton
  from 'components/dashboard/preview-content/ViewLiveButton';

import { PUBLIC_SITE_URL } from 'utils/restapi';

import './DashboardPreviewContent.css';

function DashboardPreviewContent(props) {
  const { me, actionSuccessNotification } = props;

  useEffect(() => {
    if (actionSuccessNotification) {
      document.getElementById('public-page-frame-id').src += '';
    }
  }, [actionSuccessNotification]);

  return (
    <div className="dashboard-preview-content__component">
      <div className="smartphone">
        <div className="content">
          <div className="loader-wrapper">
            <CommonLoader local />
          </div>
          <iframe
            id="public-page-frame-id"
            src={`${PUBLIC_SITE_URL}/${me.username}`}
            frameBorder={0}
          />
        </div>
      </div>

      {/* View Live Button */}
      <div className="view-live-button">
        <ViewLiveButton me={me} />
      </div>
    </div>
  );
}

DashboardPreviewContent.propTypes = {
  actionSuccessNotification: PropTypes.bool,
  me: PropTypes.object,
};

DashboardPreviewContent.defaultProps = {
  actionSuccessNotification: null,
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    actionSuccessNotification: state.commonReducer.actionSuccessNotification,
  }
);

export default connect(
  mapStateToProps,
  {},
)(DashboardPreviewContent);